import moment from "moment";

export class SongOrder {
  constructor(data) {
    var self = this;
    self.type = "SongOrder";

    self.inserted = new moment(data.inserted);

    self.rootvm = data.rootvm;

    self.gys_order_uuid = data.gys_order_uuid;

    self.email = data.email;
    self.phone = data.phone;
    self.sender_name = data.sender_name;
    self.receiver_name = data.receiver_name;
    self.song_story = data.song_story;
    self.song_important = data.song_important;

    self.song_language = data.song_language;
    self.genre = data.genre;
    self.stimmung = data.stimmung;
    self.anlass = data.anlass;
    self.amount = data.amount;
    self.status = data.status;
    self.payment_method = data.payment_method;
    self.invoice_name = data.invoice_name;
    self.invoice_address = data.invoice_address;
    self.currency = data.currency;

    self.user_feedback = data.user_feedback;
    self.user_rating = data.user_rating;

    self.fee_invoice = data.fee_invoice;
    self.artist = data.artist;

    self.row_css =
      self.status != "delivered"
        ? self.status == "canceled"
          ? "table-danger"
          : "table-warning"
        : "table-success";
  }
}
